<div id="webcamaccessnotificationdiv" #webcamAccessNotificationDiv 
    role="alert"
    aria-live="assertive"
    aria-atomic="true">
    Proctor will need access to your webcam and microphone
</div>
